import { all, put, takeEvery, select, call } from 'redux-saga/effects'
import moment from 'moment'
import DashboardActions from './actions'
import {
  dashboardSetState,
  convertTime,
  getPatientBoxPlotData,
  clinicSetState,
  // pushTrackingReport,
} from '../actions'
import { getClinicFloors } from '../clinic/sagas'
import { apiPaths } from '../../config'
import {
  http,
  getTimezoneOfAnyDeviceFromPatientsArray,
  notification,
  analytics,
} from '../../services/index'

const getClinic = (state) => state.clinic
const getUser = (state) => state.user
const getDashboard = (state) => state.dashboard

function allMetrics(requestPayload) {
  return new Promise((resolve) =>
    getAllMetricsOfPatients(requestPayload)
      .then((result) => resolve(result))
      .catch(() => []),
  )
}

function cardGraphData(requestPayload) {
  return new Promise((resolve) =>
    getPatientBoxPlotData(requestPayload)
      .then((result) => resolve(result))
      .catch(() => []),
  )
}

const getDashboardPatients = (data) =>
  http
    .get(apiPaths.Clinic.apiPatientListDB, data, {})
    .then((res) => res)
    .catch((err) => {
      notification.error(`unable to fetch patients`, `Something went wrong ${err}`)
      return []
    })

export const getLastRRForAllPatients = (data) =>
  http
    .get(apiPaths.Clinic.apiLastRRForAllPatients, data, {})
    .then((res) => res)
    .catch((err) => {
      notification.error(`unable to fetch last RR for paitents`, `Something went wrong ${err}`)
      return []
    })

const getAllMetricsOfPatients = (data) =>
  http
    .get(apiPaths.Clinic.apiDashboardMetrics, data, {})
    .then((res) => res)
    .catch((err) => {
      notification.error(`unable to fetch last RR for paitents`, `Something went wrong ${err}`)
      return []
    })

const dashboardTypes = {
  minInfo: 'Simple',
  default: 'Default',
  moreInfo: 'Detailed',
}

export function* SET_DASHBOARD_TYPE() {
  const user = yield select(getUser)
  const { dashboardType, selectedFloor } = yield select(getDashboard)
  const userData = JSON.parse(localStorage.getItem(user.id)) || {}
  if (Object.keys(userData).length > 0) {
    yield put(
      dashboardSetState({
        dashboardType: userData.userSettings.dashboardType,
        userSettingsData: userData,
        selectedFloor: userData.userSettings.selectedFloor || 'all',
      }),
    )
  } else {
    yield put(dashboardSetState({ dashboardType, selectedFloor }))
    localStorage.setItem(
      user.id,
      JSON.stringify({
        ...userData,
        userSettings: { ...userData.userSettings, dashboardType, selectedFloor },
      }),
    )
  }
}

export function* GET_CLINIC_PATIENTS_DB_OTHER_DATA({ payload }) {
  const { patientList, dashboardType } = yield select(getDashboard)
  let typeOfView = dashboardType
  if (Object.keys(payload).length > 0 && payload.dashboardType !== typeOfView) {
    typeOfView = payload.dashboardType
  }
  const { userClinic } = yield select(getClinic)
  const requestPayload = {
    report: 'daily',
    date: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    clinic_id: userClinic.id,
  }
  const requestTIBPayload = {
    clinic_id: userClinic.id,
  }
  patientList.map((item) => {
    if (item.device.device_id) {
      requestPayload.patient_id = item.patient_id
      requestPayload.structure = 'out'
      requestTIBPayload.patient_id = item.patient_id

      if (!item.timeInBed) {
        const dataResponse = allMetrics(requestPayload)
        dataResponse.then((allData) => {
          let formatedTimeInBed = '--'
          let rScore = { upper_score: null, lower_score: null }
          if (allData) {
            if (allData.tib > 0) {
              const h = Math.round(allData.tib)
              formatedTimeInBed = `${h}h`
            }
            rScore = { upper_score: allData.upper_score, lower_score: allData.lower_score }
          }

          item.timeInBed = formatedTimeInBed
          item.rScore = rScore
        })
      }

      if (typeOfView === 'moreInfo' && !item.graphData) {
        const response = cardGraphData(requestPayload)
        response
          .then((graphData) => {
            item.graphData = graphData.rr
          })
          .catch(() => {
            item.graphData = []
          })
      }

      return item
    }
    return false
  })

  // Calling Report Logging
  analytics.event({
    action: 'get_other_data',
    category: 'dashboad',
    label: dashboardTypes[typeOfView],
    value: typeOfView,
  })
}
export function* GET_CLINIC_PATIENTS_DB({ payload }) {
  let { data } = payload
  yield call(SET_DASHBOARD_TYPE)
  yield put(dashboardSetState({ loading: true, patientList: [] }))
  const { userClinic } = yield select(getClinic)
  data = {
    clinic_id: userClinic.id,
    status: 3,
    ...data,
  }
  // making all 3 API in parallel
  const [patientList, lastRRForAllPatients, clinicFloors] = yield all([
    call(getDashboardPatients, data),
    call(getLastRRForAllPatients, { clinic_id: userClinic.id }),
    call(getClinicFloors, { clinic_id: userClinic.id }),
  ])
  yield put(clinicSetState({ clinicFloorsLoading: false, clinicFloors }))

  if (patientList.length > 0) {
    if (!userClinic.tz) {
      userClinic.tz = getTimezoneOfAnyDeviceFromPatientsArray(patientList)
    }
    patientList.map((item) => {
      item.holdValue = true
      if (lastRRForAllPatients && lastRRForAllPatients.length > 0) {
        lastRRForAllPatients.map((singleRRObj) => {
          if (
            singleRRObj.device_id === item.device.device_id &&
            item.device.device_conn_status !== 0
          ) {
            item.rr_last_mint = singleRRObj.rr_last_mint
            item.holdValue = true
            item.lastUpdated = singleRRObj.rr_last_mint.tracker_ts
            item.cardFlashTimer = singleRRObj.rr_last_mint.tracker_ts
            item.dist_rr = singleRRObj.dist_rr
            if (item.lastUpdated) {
              const currentTimeConvert = convertTime(
                moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                item.device.device_tz,
                'YYYY-MM-DD HH:mm:ss',
              )
              const duration = moment.duration(
                moment(currentTimeConvert).diff(
                  new Date(
                    convertTime(
                      singleRRObj.rr_last_mint.tracker_ts,
                      item.device.device_tz,
                      'YYYY-MM-DD HH:mm:ss',
                    ),
                  ).getTime(),
                ),
              )

              if (duration.hours() === 0 && duration.minutes() <= 3) {
                item.cardFlash = true
              } else {
                item.cardFlash = false
              }
            }

            item.changeLabel = true
          }
          return true
        })
      }
      return false
    })
  }
  yield put(dashboardSetState({ loading: false, patientList }))
  yield put(dashboardSetState({ userClinic }))
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(DashboardActions.GET_CLINIC_PATIENTS_DB, GET_CLINIC_PATIENTS_DB),
    takeEvery(
      DashboardActions.GET_CLINIC_PATIENTS_DB_OTHER_DATA,
      GET_CLINIC_PATIENTS_DB_OTHER_DATA,
    ),
    takeEvery(DashboardActions.SET_DASHBOARD_TYPE, SET_DASHBOARD_TYPE),
  ])
}
